$(function() {
  $(".contact-us-form").validate({
      rules : {
          "contact_us[name]": {
              required: true
          },
          "contact_us[email]": {
              required: true,
              email: true
          },
          "contact_us[phone]": {
              required: true
          },
          "contact_us[affiliation]": {
              required: true
          },
          "contact_us[inquiry_type]": {
              required: true
          },
          "contact_us[inquiry_content]": {
              required: true
          },
      },
      messages: {
          "contact_us[name]":{
              required: "必須項目です。入力をお願いします。"
          },
          "contact_us[email]":{
              required: "必須項目です。入力をお願いします。",
              email: "有効なメールアドレスを入力してください。"
          },
          "contact_us[phone]":{
              required: "必須項目です。入力をお願いします。",
          },
          "contact_us[affiliation]":{
              required: "必須項目です。入力をお願いします。",
          },
          "contact_us[inquiry_type]": {
              required: "必須項目です。入力をお願いします。",
          },
          "contact_us[inquiry_content]": {
              required: "必須項目です。入力をお願いします。",
          },
      },
  });

  $(".contact-us-form input, .contact-us-form select, .contact-us-form textarea").on('keyup change', function () {
    change_submit_button_behavior();
  })

  function change_submit_button_behavior() {
    if($(".contact-us-form").validate().checkForm()) {
       $(".input-complete-registration").css("opacity", 1)
      return $('.input-complete-registration').removeClass('button_disabled').prop('disabled', false)
    }
    $(".input-complete-registration").css("opacity", 0.5)
    return  $('.input-complete-registration').addClass('button_disabled').prop('disabled', true)
  }

});